
import Vue, { i18n } from '/vodalys/vvuejs/vue.js'


import './translate25localeLoader.mjs'

// if (process.env.NODE_ENV !== 'production') {
    // i18n.silentFallbackWarn = false
    // i18n.silentTranslationWarn = false
// }

// i18n.mergeLocaleMessage('en', flattenTranslations(messages))

import translate25Plugin from './translate25Plugin'
Vue.use(translate25Plugin)